import { Controller } from 'react-hook-form'
import UserFormField from '../../User/UserFormField'
import { useFormContextRequester } from '../utils/_utils'
import { ucfirst } from 'libs/ordoclic/src/lib/utilities'

const FirstName = () => {
    const { control } = useFormContextRequester()

    return (
        <Controller
            control={control}
            name="firstName"
            render={({ field, fieldState: { error } }) => (
                <UserFormField
                    variant="input"
                    label="Prénom d’exercice"
                    placeholder="Prénom d’exercice"
                    locked
                    disabled
                    status={{
                        error,
                        valid: (field.value?.trim().length ?? 0) > 0,
                    }}
                    {...field}
                    value={ucfirst(field?.value ?? '')}
                />
            )}
        />
    )
}

export default FirstName
